export default function fixArray<T>(input: T | T[]): T[] {
  if (input === null || input === undefined) {
    return [];
  }
  return Array.isArray(input) ? input : [input];
}
